export function safeNestedFormatter(field: string, safeValue = '') {
  return ({ value }) => {
    if (value) {
      return value[field];
    } else {
      return safeValue;
    }
  };
}

export function safeNestedValueFormatter(field: string, safeValue = '') {
  return ({ value }) => {
    if (value[field]) {
      return value[field];
    } else {
      return safeValue;
    }
  };
}
